import { getValueByPath, QUESTION_CHILD_KEYS } from "./questionTree";

function normalizeBlockedByRules(blockedBy) {
  if (!blockedBy) return [];
  return Array.isArray(blockedBy) ? blockedBy : [blockedBy];
}

function valueMatchesBlockedRule(value, rule) {
  if (
    !rule ||
    (!Object.prototype.hasOwnProperty.call(rule, "answer") && !rule.answers)
  ) {
    return false;
  }

  const expectedValues = Array.isArray(rule.answers)
    ? rule.answers
    : [rule.answer];

  return expectedValues.some((expectedValue) => value === expectedValue);
}

function nodeMatchesBlockedRule(node, inheritedSection, rule) {
  if (!node || !rule) return false;

  const section = node.section || inheritedSection || {};
  if (rule.sectionNumber && section.number !== rule.sectionNumber) {
    return false;
  }
  if (rule.sectionTitle && section.title !== rule.sectionTitle) {
    return false;
  }
  if (rule.identifier && node.identifier !== rule.identifier) {
    return false;
  }
  if (rule.question && node.question !== rule.question) {
    return false;
  }

  const answerField = rule.answerField || "answer";
  return valueMatchesBlockedRule(getValueByPath(node, answerField), rule);
}

function hasBlockedByMatchInNode(node, inheritedSection, rule) {
  if (!node) return false;

  const section = node.section || inheritedSection;
  if (nodeMatchesBlockedRule(node, section, rule)) {
    return true;
  }

  return QUESTION_CHILD_KEYS.some(
    (childKey) =>
      Array.isArray(node[childKey]) &&
      node[childKey].some((childNode) =>
        hasBlockedByMatchInNode(childNode, section, rule)
      )
  );
}

export function isResponseBlocked(questions, blockedBy) {
  const rules = normalizeBlockedByRules(blockedBy);
  if (rules.length === 0) return false;

  return rules.some((rule) =>
    (questions || []).some((question) =>
      hasBlockedByMatchInNode(question, question && question.section, rule)
    )
  );
}

export function sanitizeBlockedResponses(questions) {
  return (questions || []).map((question) => {
    if (
      question &&
      question.blockedResponses &&
      question.answer &&
      isResponseBlocked(questions, question.blockedResponses[question.answer])
    ) {
      return {
        ...question,
        answer: "",
      };
    }

    return question;
  });
}
